import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "synthesizer",
  style: {"width":"200px","height":"20px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "circle_button skyblueBg hoverGreyBg",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startCall && _ctx.startCall(...args))),
      style: {"width":"120px","height":"120px","border-radius":"50%"}
    }, [
      _createElementVNode("img", {
        src: _ctx.$getAssetImageUrl(`/assets/icons/onsei_wt.png`),
        width: "60",
        height: "60",
        class: "mt20"
      }, null, 8, _hoisted_2)
    ]),
    _hoisted_3,
    (_ctx.isCallActive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (bar) => {
            return _createElementVNode("div", {
              key: bar,
              class: "bar skyblueBg",
              style: _normalizeStyle({ height: `${_ctx.barHeights[bar - 1]}%` })
            }, null, 4)
          }), 64))
        ]))
      : _createCommentVNode("", true),
    _hoisted_5
  ]))
}